import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import organizationsReducer from "./slices/organizationsSlice";
import participantsReducer from "./slices/participantsSlice";
import usersReducer from "./slices/usersSlice";
import uiReducer from "./slices/uiSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    organizations: organizationsReducer,
    participants: participantsReducer,
    users: usersReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Re-export auth actions for easier imports
export {
  checkAuthStatus,
  login,
  register,
  verify2FA,
  logout,
  logoutAll,
  updateProfile,
  clearError,
  reset2FA,
  sessionExpired,
  reloginSucceeded,
} from "./slices/authSlice";
